import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

export default function useAllCellDecreaseTypes() {
  const [loading, setLoading] = useState(true);
  const [decrease, setDecrease] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const getAllCellDecreaseTypes = () => {
    setLoading(true);
    axiosClient
      .get('/InventoryAddress/GetAllDecreaseTypes')
      .then(res => {
        if (res.status === 200) {
          setDecrease(res.data.value);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => {
        setLoading(false);
      });
  };

  return [loading, decrease, getAllCellDecreaseTypes];
}
